import { PopoverTrigger } from "@chakra-ui/react";
import { selectUserId } from "domain/auth/auth.selectors";
import { PropsWithChildren, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "ui/hook/store";
import { translate } from "ui/i18n";
import { CustomTooltip } from "ui/pages/app/components/CustomTooltip";
import { CustomTextTooltip } from "ui/pages/app/components/CustomTextTooltip";
import { selectOnBoardingValues } from "domain/on-boarding/on-boarding.selectors";
import { updateOnBoardingValue } from "ui/utils/on-boarding-storage";

export const DownloadActivityTooltip = ({
  children,
  mobile,
  type,
}: PropsWithChildren<{ mobile?: boolean; type: "technique" | "seance" }>) => {
  // const [isClosed, setIsClosed] = useState(false);
  const dispatch = useAppDispatch();
  const onBoardingValues = useAppSelector(selectOnBoardingValues);
  const userId = useAppSelector(selectUserId);

  const closeDownloadTooltip = () => {
    if (!onBoardingValues.closedDownloadAdvice) {
      updateOnBoardingValue(userId, "closedDownloadAdvice", dispatch);
    }
  };

  useEffect(() => {
    window.addEventListener("beforeunload", closeDownloadTooltip);
    return () => {
      closeDownloadTooltip();
    };
  }, []); //eslint-disable-line

  return onBoardingValues.closedDownloadAdvice ? (
    mobile ? (
      <PopoverTrigger>{children}</PopoverTrigger>
    ) : (
      <CustomTextTooltip
        text={
          type === "technique"
            ? translate("ns1:Activities.Tooltips.DownloadPDF")
            : translate("ns1:Activities.Tooltips.DownloadPDF")
        }
      >
        {children}
      </CustomTextTooltip>
    )
  ) : (
    <CustomTooltip
      open
      onClose={closeDownloadTooltip}
      title={translate("ns1:OnBoarding.Tooltips.DownloadTitle")}
      text={translate("ns1:OnBoarding.Tooltips.DownloadText")}
    >
      {children}
    </CustomTooltip>
  );
};
